import React from 'react';
import { CURRENT_USER } from '@ventureroom/core';
import { useApp, useData } from './provider';
import { Button, Column, Copy, Heading, Row } from './components';

export function VentureInvitation({ id }: { id: string }) {
  const data = useData(),
    app = useApp();
  const invitation = data.invitations.find((i) => i.id === id && i.kind === 'invitation');
  if (!invitation) return null;
  const venture = data.ventures.find((v) => v.id === invitation.ventureId);
  return (
    <Column gap={10}>
      <Copy muted size={11}>
        VENTURE INVITATION
      </Copy>
      <Heading size={20}>{venture?.name ?? 'Venture'}</Heading>
      <Button kind="secondary" onPress={() => app.navigate(`venture/${invitation.ventureId}`)}>
        View venture
      </Button>
      {invitation.status === 'pending' && invitation.to === CURRENT_USER ? (
        <Row wrap>
          <Button
            disabled={app.busy}
            onPress={() =>
              void app.act({ type: 'invitationRespond', id, accept: true }, 'Invitation accepted')
            }
          >
            Accept invitation
          </Button>
          <Button
            disabled={app.busy}
            kind="quiet"
            onPress={() =>
              void app.act({ type: 'invitationRespond', id, accept: false }, 'Invitation declined')
            }
          >
            Decline invitation
          </Button>
        </Row>
      ) : (
        <Copy muted size={12}>
          {invitation.status === 'pending'
            ? 'Awaiting acceptance'
            : invitation.status === 'accepted'
              ? 'Invitation accepted'
              : invitation.status === 'cancelled'
                ? 'Invitation cancelled'
                : 'Invitation declined'}
        </Copy>
      )}
    </Column>
  );
}
